import { AUTH_BASE_URL } from '../config/api';

const API_BASE_URL = AUTH_BASE_URL;

// Get all teams
export const fetchTeams = async () => {
  const response = await fetch(`${API_BASE_URL}/api/teams`, {
    credentials: 'include',
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch teams');
  }
  
  return response.json();
};

// Get a specific team
export const fetchTeam = async (id) => {
  const response = await fetch(`${API_BASE_URL}/api/teams/${id}`, {
    credentials: 'include',
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch team');
  }
  
  return response.json();
};

// Create a new team
export const createTeam = async (data) => {
  const response = await fetch(`${API_BASE_URL}/api/teams`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(data),
  });
  
  if (!response.ok) {
    throw new Error('Failed to create team');
  }
  
  return response.json();
};

// Update team
export const updateTeam = async (id, data) => {
  const response = await fetch(`${API_BASE_URL}/api/teams/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(data),
  });
  
  if (!response.ok) {
    throw new Error('Failed to update team');
  }
  
  return response.json();
};

// Delete team
export const deleteTeam = async (id) => {
  const response = await fetch(`${API_BASE_URL}/api/teams/${id}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  
  if (!response.ok) {
    throw new Error('Failed to delete team');
  }
  
  return response.json();
};

// Add member to team
export const addTeamMember = async (teamId, memberData) => {
  const response = await fetch(`${API_BASE_URL}/api/teams/${teamId}/members`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(memberData),
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to add member');
  }
  
  return response.json();
};

// Update member role
export const updateMemberRole = async (teamId, memberId, role) => {
  const response = await fetch(`${API_BASE_URL}/api/teams/${teamId}/members/${memberId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ role }),
  });
  
  if (!response.ok) {
    throw new Error('Failed to update member role');
  }
  
  return response.json();
};

// Remove member from team
export const removeMember = async (teamId, memberId) => {
  const response = await fetch(`${API_BASE_URL}/api/teams/${teamId}/members/${memberId}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  
  if (!response.ok) {
    throw new Error('Failed to remove member');
  }
  
  return response.json();
};

// Update team permissions
export const updateTeamPermissions = async (teamId, permissions) => {
  const response = await fetch(`${API_BASE_URL}/api/teams/${teamId}/permissions`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(permissions),
  });
  
  if (!response.ok) {
    throw new Error('Failed to update permissions');
  }
  
  return response.json();
};